module.exports = __webpack_public_path__ + "static/media/Lets_Connect_with_text_white.f2f0a0da.png";